
import React from 'react';
import AddModifierGroups from './AddModifierGroups';
import DashboardLayout from '../../../components/Shop/StoreLayout/Layout/DashboardLayout';
import Layout from '../../../components/Layout';
import NotFound from '../../not-found/NotFound';
import messages from '../../../locale/messages';

function action({ store, intl }) {
  const title = intl.formatMessage(messages.modifierGroup);
  let isStoreAuthenticated = store.getState().runtime.isStoreAuthenticated;
  let isEnableAddon = store.getState().siteSettings.data.addons;

  if (!isStoreAuthenticated) {
    return { redirect: '/store/login' };
  };

  if (isEnableAddon === '0') {
    return {
      title,
      component: <Layout><NotFound title='Page Not Found' /></Layout>,
      status: 404,
    };
  }

  return {
    title,
    component: (
      <DashboardLayout>
        <AddModifierGroups title={title} />
      </DashboardLayout>
    ),
  };
}

export default action;
